export const DEVICE_TOKEN_KEY = "bibleImposter.deviceToken"

export function readDeviceToken() {
  return localStorage.getItem(DEVICE_TOKEN_KEY)
}

export function getOrCreateDeviceToken() {
  const existing = localStorage.getItem(DEVICE_TOKEN_KEY)

  if (existing) {
    return existing
  }

  const token = crypto.randomUUID()
  localStorage.setItem(DEVICE_TOKEN_KEY, token)
  return token
}
